import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import * as ResponsiveImageHelper from "@/components/General/Image/helpers/responsiveImage.helpers";
import { Image } from "@/components/General/Image/image";
import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

import { useCollectionsContext } from "../context/collections.context";

const Collection = () => {
    const { collections } = useCollectionsContext();
    const { setSelectedCollection, nextStep } = usePaintConfiguratorContext();
    const { index } = useMapped();

    const collection = collections.at(index);
    if (!collection) return null;

    const imageProps = collection.responsiveImage
        ? ResponsiveImageHelper.toImageProps({
              image: collection.responsiveImage
          })
        : undefined;

    return (
        <Button
            color={"transparent"}
            className={cn(
                "tw:p-0 tw:relative tw:border tw:overflow-hidden tw:text-left tw:border-gray-300 tw:hover:shadow-lg tw:transition-all",
                "tw:flex tw:flex-col"
            )}
            onClick={() => {
                setSelectedCollection(collection.id);
                nextStep();
            }}
        >
            <div
                style={{
                    backgroundColor: collection.backgroundColor
                        ? `#${collection.backgroundColor.replace("#", "")}`
                        : undefined
                }}
                className={cn(
                    "tw:aspect-4/3 tw:w-full tw:transition-transform tw:duration-300"
                )}
            >
                {imageProps && (
                    <Image {...imageProps}>
                        <Image.Img />
                    </Image>
                )}
            </div>
            <div className={cn("tw:p-3 md:tw:p-4 tw:bg-white tw:h-full")}>
                <p
                    className={cn(
                        "tw:font-semibold tw:text-grey-dark tw:mt-2 tw:mb-2"
                    )}
                >
                    {collection.name}
                </p>
                <p
                    className={cn(
                        "tw:text-xs tw:text-grey-dark tw:line-clamp-3 tw:min-h-12"
                    )}
                    title={collection.description}
                >
                    {collection.description}
                </p>
            </div>
        </Button>
    );
};

export { Collection };
